import script from "./sponsors.vue?vue&type=script&setup=true&lang=js"
export * from "./sponsors.vue?vue&type=script&setup=true&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=62a22c64&lang=css"

const __exports__ = script;

export default __exports__